import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TimeAgoPipe } from './time-ago.pipe';
import { FileSizePipe } from './file-size.pipe';
import { ToJpgPipe } from './to-jpg.pipe';
import { CapitalizePipe } from './capitalize.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [TimeAgoPipe, FileSizePipe, ToJpgPipe, CapitalizePipe],
  exports: [TimeAgoPipe, FileSizePipe, ToJpgPipe, CapitalizePipe]
})
export class PipeModule {}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/_shared/pipes/pipe.module.ts